import { useTheme } from "@/hooks/useTheme"
import { Toaster as Sonner, ToasterProps } from "sonner"

/** The viewer's bottom action toolbar on a phone (pointer-coarse buttons + its 8 px inset) plus a gap. */
export const TOAST_MOBILE_BOTTOM_PX = 64

const Toaster = ({ ...props }: ToasterProps) => {
  const theme = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      // Phones: toasts sit above the viewer's bottom action toolbar instead of
      // covering it (r3 M8). Desktop placement is unchanged; a caller may override.
      mobileOffset={{ bottom: TOAST_MOBILE_BOTTOM_PX }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
